import React, { useState } from "react";
import { Modal, ModalBody, ModalHeader } from "react-bootstrap";
import ReactPanZoom from "react-image-pan-zoom-rotate";
import "./image-view-modal.css";
import ImageViewOption from "./image-view-option";
import { getFileExtension } from "../../utilites/helper";

const ImageViewModal = ({
  show,
  ShowClose,
  imageUrlData,
  imageTitleData,
  muliImageData = [],
  setImageUrlData,
}) => {
  const [active, setactive] = useState(0);
  // const [fileExtension, setfileExtension] = useState(getFileExtension(imageUrlData))
  // console.log("imageUrlDataimageUrlData", imageUrlData);
  // console.log(fileExtension, "getFileExtensiongetFileExtensiongetFileExtension");


  return (
    <Modal
      centered
      show={show}
      onHide={ShowClose}
      dialogClassName="image-viewer-container col-11 px-sm-5 px-4 mx-auto"
      size="lg"
    >
      <ModalHeader
        className="d-flex justify-content-between align-items-center"
        closeButton
      >
        <span className="fn_Nunito fw_600 fs_18 px-2">Image</span>
      </ModalHeader>
      <ModalBody className="text-nowrap">
        {imageUrlData && getFileExtension(imageUrlData) === "pdf" ?
          <div className="imageview-container p-md-2">
            <iframe src={imageUrlData} alt="Not a proper Image" className="h-100 w-100" />
          </div> :
          <div className="imageview-container p-md-2">
            <ImageViewOption image={imageUrlData} alt="Not a proper Image" />
          </div>
        }
        <div className="mx-auto multi-image-container">
          {muliImageData?.length > 1 && (
            <div className="d-flex justify-content-center gap-sm-5 py-1">
              {muliImageData?.map((item, index) => (
                <>
                  <div
                    className="text-center mx-4"
                    onClick={() => {
                      setImageUrlData(item?.url);
                      setactive(index);
                    }}
                  >
                    <img className="invoice-list-image" src={item?.url} />
                    <div
                      className={
                        active === index
                          ? "fs_14 mt-1 color_2ad3e7"
                          : "fs_14 mt-1 color_747f9e"
                      }
                    >
                      {item?.invoice_id}
                    </div>
                  </div>
                </>
              ))}
            </div>
          )}
        </div>
      </ModalBody>
    </Modal>
  );
};

export default ImageViewModal;
